const UserPrize = () => import('@/views/Prize/user-prize.vue')
const Prize = () => import('@/views/Prize/prize.vue')

const router = [
  {
    meta: {title: '幸运号码', route: 'prize_index'},
    path: 'prize',
    name: 'prize',
    component: Prize
  },
  {
    meta: {title: '抽奖号码', route: 'user_prize_index'},
    path: 'user-prize',
    name: 'user-prize',
    component: UserPrize
  }
]
module.exports = {router};
